import { indentstatusenum } from "@gtpl/shared-models/common-models";
import { Column, CreateDateColumn, Entity, OneToMany, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { IndentItemEntity } from "./indent-item-entity";

@Entity('indent_material_preparation')
export class IndentMaterialEntity {
    @PrimaryGeneratedColumn('increment',{
        name:'indent_material_preparation_id'
    })
    indentMaterialPreparationId:number

    @Column('datetime', {
        nullable: false,
        name: 'indent_date',
    })
    indentDate: Date;

    @Column('int', {
        nullable: false,
        name: 'employee_id',
    })
    employeeId: number;

    @Column('varchar', {
        nullable: false,
        length: 40,
        name: 'indent_code'
    })
    indentCode: string;
    @Column('varchar',{
        nullable:false,
        length:20,
        name:'indent_against',
    })
    indentAgainst:string;
    
    @Column('int', {
        nullable: true,
        name: 'sale_order_item_id',
    })
    saleOrderItemId: number;
    
    @Column('int', {
        nullable: false,
        name: 'sale_order_id',
    })
    saleOrderId: number;

    @Column('int', {
        nullable: false,
        name: 'unit_id',
        default: 0
    })
    unitId: number;
    
    @CreateDateColumn({
        name: 'created_at'
    })
    createdAt: Date;

    @Column('varchar', {
        nullable: true,
        length: 40,
        name: 'created_user'
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: 'updated_at'
    })
    updatedAt: Date;

    @Column('varchar', {
        nullable: true,
        length: 40,
        name: 'updated_user'
    })
    updatedUser: string | null;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;
    
    @Column("boolean", {
        nullable: false,
        default: true,
         name: "is_active"
        })
        isActive: boolean;

    @Column({
        type: "enum",
        nullable: false,
        name: "status",
        enum: indentstatusenum,
        default: indentstatusenum.OPEN,
      })
      status: string;


    @OneToMany(type => IndentItemEntity,indentitems =>indentitems.indentMaterialEntityInfo, {cascade:true})
    indentItemDetails:IndentItemEntity[];
}